import React from 'react';

const FoodList = ({ items, cart, updateCart }) => {
    
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {items.map(item => {
                const quantity = cart[item.name] || 0;
                return (
                    <div
                        key={item.name}
                        className="bg-white rounded-xl shadow-lg overflow-hidden card-transform-hover flex flex-col"
                    >
                        <img
                            src={item.image}
                            alt={item.name}
                            className="w-full h-48 object-cover"
                            onError={e => (e.target.src = 'https://placehold.co/300x200/cccccc/000000?text=Image+Not+Found')}
                        />
                        <div className="p-4 flex flex-col flex-grow">
                            <h5 className="text-xl font-semibold text-gray-800 mb-2">{item.name}</h5>
                            <p className="text-gray-600 mb-3">Price: ₹{quantity > 0 ? quantity * item.price : item.price}</p>

                            {quantity === 0 ? (
                                <button
                                    onClick={() => updateCart(item.name, 1)}
                                    className="bg-orange-500 text-white px-4 py-2 rounded-full font-medium w-full hover:bg-orange-600 transition duration-300 shadow-md"
                                >
                                    Add to Cart
                                </button>
                            ) : (
                                <div className="flex justify-center space-x-3">
                                    <button
                                        onClick={() => updateCart(item.name, quantity - 1)}
                                        className="bg-red-500 text-white px-3 py-1 rounded-full font-bold hover:bg-red-600 transition duration-300"
                                    >
                                        -
                                    </button>
                                    <span className="text-lg font-semibold">{quantity}</span>
                                    <button
                                        onClick={() => updateCart(item.name, quantity + 1)}
                                        className="bg-green-500 text-white px-3 py-1 rounded-full font-bold hover:bg-green-600 transition duration-300"
                                    >
                                        +
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default FoodList;